import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TierProductCardDumbDesktop from './TierProductCardDumbDesktop';
import TierProductCardDumbMobile from './TierProductCardDumbMobile';
const TierProductCardDumb = (props)=>{
    const isMobile = useContext(MobileContext);
    return isMobile ? /*#__PURE__*/ React.createElement(TierProductCardDumbMobile, _extends({}, props)) : /*#__PURE__*/ React.createElement(TierProductCardDumbDesktop, _extends({}, props));
};
TierProductCardDumb.displayName = 'TierProductCardDumb';
export default TierProductCardDumb;
